import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function TermsOfService() {
  return (
    <div className="min-h-screen bg-slate-50 dark:bg-[#030712] text-slate-900 dark:text-slate-200 font-body py-16 px-4 sm:px-6 transition-colors duration-300">
      <div className="max-w-4xl mx-auto space-y-8 glass-panel p-8 md:p-12 rounded-3xl">
        <Link to="/" className="inline-flex items-center gap-2 text-xs font-bold text-blue-600 dark:text-cyan-400 hover:underline font-heading">
          <ArrowLeft size={14} /> Back to Home
        </Link>

        <div className="space-y-2">
          <span className="text-xs font-bold uppercase tracking-widest text-blue-600 dark:text-cyan-400 font-heading">Legal Terms</span>
          <h1 className="font-heading text-3xl font-extrabold text-slate-900 dark:text-white">Terms of Service</h1>
          <p className="text-xs text-slate-500 dark:text-slate-400">Last updated: August 2026</p>
        </div>

        <div className="space-y-6 text-sm text-slate-700 dark:text-slate-300 leading-relaxed font-medium">
          <section className="space-y-2">
            <h3 className="font-heading text-lg font-bold text-slate-900 dark:text-white">1. Scope of Agreement</h3>
            <p>
              By accessing or engaging Hickter Technology Solutions, you agree to these Terms of Service governing website development, mobile application engineering, and digital marketing contracts.
            </p>
          </section>

          <section className="space-y-2">
            <h3 className="font-heading text-lg font-bold text-slate-900 dark:text-white">2. Intellectual Property Rights</h3>
            <p>
              Upon complete contract milestone settlement and final UAT signoff, full source code ownership, intellectual property rights, and design assets are transferred to the client.
            </p>
          </section>

          <section className="space-y-2">
            <h3 className="font-heading text-lg font-bold text-slate-900 dark:text-white">3. SLA & Technical Support</h3>
            <p>
              Hickter guarantees system uptime and dedicated technical support as specified in individual contract level agreements (SLA).
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}
